import React, { Component } from 'react';
import { change } from 'redux-form';
import FormField from './FormField';
import PropTypes from 'prop-types';
import DropdownField from './DropdownField';
import { connect } from 'react-redux';

class StateField extends Component {
    static propTypes = {
      venue: PropTypes.object,
      error: PropTypes.string
    };

    componentDidUpdate(prevProps) {
      if ( !this.props.venue.country || !prevProps.venue.country)
        return;
     
      if (this.props.venue.country.iso_alpha2 !== prevProps.venue.country.iso_alpha2) {
        let newData = Object.assign({}, this.props.venue);
        newData.state = { name: '', code: ''};
        this.props.dispatch(change('eventSubmission', 'venue', newData));
      }
    }

    render () {
      let stateComponent = 'input';
      let stateInputProps = null;
      let stateData = null;
      let fieldName = 'venue.state.name';

      if (this.props.venue.country && this.props.venue.country.iso_alpha2 === 'US') {
        stateComponent = DropdownField;
        stateData = this.props.venue.country.states;
        stateInputProps = { valueField: 'code', textField: 'name'};
        fieldName = 'venue.state';
      }

      return (
        <FormField
          placeholder="State/Province"
          name={fieldName}
          className="form-control"
          type="text"
          error={this.props.error}
          component={stateComponent}
          inputProps={stateInputProps}
          data={stateData}
        />
      );
    }
}

const mapStateToProps = (state) => ({
  venue:  state.form.eventSubmission.values.venue,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StateField);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/StateField.jsx